module.exports = __webpack_public_path__ + "static/img/jipiao.434494e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jipiao.png
// module id = yN0i
// module chunks = 0